import React from 'react';

import useFormContext from 'dpl/shared/form/hooks/useFormContext';

import SimpleTextarea from './SimpleTextarea';

interface TextareaProps extends Record<string, any> {
  labelProps?: {
    htmlFor?: string;
    text?: string;
    className?: string;
    newDesignSystemStyles?: boolean;
  };
  onChange?: ((e: React.ChangeEvent<HTMLTextAreaElement>) => void) | null;
  name: string;
  newDesignSystemStyles?: boolean;
  placeholder?: string | null;
}

export default function Textarea({
  onChange = null,
  name,
  labelProps = {},
  placeholder = null,
  newDesignSystemStyles = false,
  ...textareaProps
}: TextareaProps) {
  const {
    formFieldErrors,
    formFieldId,
    formFieldValue,
    handleFormFieldChange
  } = useFormContext(name);

  return (
    <SimpleTextarea
      errors={formFieldErrors}
      id={formFieldId}
      name={name}
      placeholder={placeholder}
      onChange={onChange || handleFormFieldChange}
      value={formFieldValue}
      labelProps={labelProps}
      newDesignSystemStyles={newDesignSystemStyles}
      {...textareaProps}
    />
  );
}
